import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRole from '@role/store/role.reducer';

export const getRoleState = createFeatureSelector(fromRole.roleFeatureKey);
export const getCollection = createSelector(getRoleState, (state: fromRole.RoleState) => state.collection);

export const fetchingCollection = createSelector(getRoleState, (state: fromRole.RoleState) => state.isFetching);

// export const getRow = createSelector(getRoleState, (state: fromRole.RoleState) => {
//   return state.row;
// });

// export const successfullyAdded = createSelector(
//   getEtlsState, (state: fromEtl.EtlState) => {
//     return {
//       row: state.row,
//       successfullyAdded: state.successfullyAdded,
//     };
//   }
// );

// export const successfullyRemoved = createSelector(
//   getEtlsState, (state: fromEtl.EtlState) => {
//     return {
//       row: state.row,
//       successfullyDeleted: state.successfullyDeleted };
//   }
// );

// export const successfullyEdited = createSelector(
//   getEtlsState, (state: fromEtl.EtlState) => {
//     return {
//       row: state.row,
//       successfullyEdited: state.successfullyEdited };
//   }
// );

export const getError = createSelector(
  getRoleState,
  (state: fromRole.RoleState) => {
    return {error: state.error, errorType: state.errorType};
  }
);

// export const actionStarted = createSelector(
//   getEtlsState,
//   (state: fromEtl.EtlState) => state.actionStarted
// );

// export const jobDetails = createSelector(
//   getEtlsState, (state: fromEtl.EtlState) => {
//     return {row: state.row, finished: state.successfullyLoaded};
//   }
// );
